(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('unsuscribe', {
                parent: 'public',
                url: '/unsuscribe?key',
                data: {
                    pageTitle: 'usuarios.unsuscribe.titulo'
                },
                views: {
                    'content@': {
                        template: '<unsuscribe></unsuscribe>'
                    }
                },
                resolve: {
                    /* @ngInject */
                    translatePartialLoader: function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('componentes/usuarios');
                    }
                }
            });
    }
})();
